export default __webpack_public_path__ + "static/media/Graphik-Light.1bff1621.otf";